import { useBundleProps } from 'signer-app/bundle-props';
import { useFeatureFlag } from 'signer-app/context/feature-flags';

export function useWhiteLabelSignerAppTextColorFixEnabled(): boolean {
  const { hasCustomStyles } = useBundleProps();
  const flagOn = useFeatureFlag(
    'sign_core_2026_03_25_white_labeling_new_signer_app_text_color_fix',
  );
  return hasCustomStyles && flagOn;
}
